import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { TechChecklist } from "@/components/TechChecklist";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export const PreventiveCompleteDialog = ({ schedule, technicians, onClose, onDone }) => {
  const { user } = useAuth();
  const [techIds, setTechIds] = useState([]);
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!schedule) { return; }
    const ids = [...(schedule.technician_ids || [])];
    if (user?.role === "tecnico" && !ids.includes(user.id)) ids.unshift(user.id);
    setTechIds(ids);
    setNotes("");
  }, [schedule, user]);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/preventive/${schedule.id}/complete`, { technician_ids: techIds, notes });
      toast.success("Preventiva concluída. Próxima data atualizada.");
      onDone();
      onClose();
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail) || e.message);
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!schedule} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="preventive-complete-dialog">
        <DialogHeader>
          <DialogTitle>Concluir preventiva</DialogTitle>
          <DialogDescription>{schedule?.equipment_tag} · {schedule?.task} — marque quem executou o serviço.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Técnicos que executaram</Label>
            <TechChecklist technicians={technicians} value={techIds} onChange={setTechIds} testPrefix="prev-complete-tech" />
          </div>
          <div>
            <Label>Observações</Label>
            <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={2} className="rounded-sm mt-1.5" data-testid="prev-complete-notes" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm">Cancelar</Button>
          <Button onClick={submit} disabled={saving} className="rounded-sm bg-green-600 hover:bg-green-700 text-white gap-2" data-testid="prev-complete-confirm">
            <CheckCircle2 className="w-4 h-4" /> {saving ? "Salvando..." : "Concluir"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
